export const SECURITY_MAX = 300

export type SecurityKind = 'redirect' | 'ip' | 'h5'

export function isHttpUrl(value: string): boolean {
  if (!/^https?:\/\//i.test(value)) return false
  try {
    const url = new URL(value)
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
    if (!url.hostname) return false
    if (/[:*]/.test(url.pathname) || /[{}]/.test(value)) return false
    return true
  } catch {
    return false
  }
}

/** 单个 IPv4。不支持 IPv6 / CIDR / 前导零。 */
function isIPv4(value: string): boolean {
  const parts = value.split('.')
  if (parts.length !== 4) return false
  return parts.every((part) => {
    if (!/^\d{1,3}$/.test(part)) return false
    const n = Number(part)
    return n >= 0 && n <= 255 && String(n) === part
  })
}

/** 单个公网 IPv4。不支持 IPv6、CIDR，以及私网和保留地址。 */
export function isPublicIPv4(value: string): boolean {
  if (!isIPv4(value)) return false
  const [a, b] = value.split('.').map(Number)
  if (a === 0 || a === 10 || a === 127) return false
  if (a === 169 && b === 254) return false
  if (a === 172 && b >= 16 && b <= 31) return false
  if (a === 192 && b === 168) return false
  if (a >= 224) return false
  return true
}

export function isValidEntry(kind: SecurityKind, value: string): boolean {
  return kind === 'ip' ? isPublicIPv4(value) : isHttpUrl(value)
}

export function parseBatchLines(text: string): string[] {
  const seen = new Set<string>()
  const items: string[] = []
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim()
    if (!line || seen.has(line)) continue
    seen.add(line)
    items.push(line)
  }
  return items
}

/** 当前列表有、下一批没有的条目（整条移除 + 被改掉的原值） */
export function deletedItems(current: string[], next: string[]): string[] {
  const nextSet = new Set(next)
  return current.filter((item) => !nextSet.has(item))
}

export function invalidLineIndexes(
  kind: SecurityKind,
  text: string,
): number[] {
  return text.split(/\r?\n/).flatMap((raw, index) => {
    const line = raw.trim()
    if (!line) return []
    return isValidEntry(kind, line) ? [] : [index]
  })
}
